/**
 * Formats SOL amounts with appropriate decimal places
 * Shows up to 6 decimal places but removes unnecessary trailing zeros
 * @param amount - The SOL amount to format
 * @returns Formatted string with SOL currency
 */
export const formatSOL = (amount: number | string): string => {
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  
  // If amount is 0 or invalid, return "0 SOL"
  if (!numAmount || isNaN(numAmount)) {
    return '0 SOL';
  }
  
  // Format to 6 decimal places and remove trailing zeros
  const formatted = numAmount.toFixed(6).replace(/\.?0+$/, '');
  
  return `${formatted} SOL`;
};

/**
 * Formats SOL amounts for display with proper precision
 * @param amount - The SOL amount to format
 * @returns Formatted number string without currency
 */
export const formatSOLAmount = (amount: number | string): string => {
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  
  // If amount is 0 or invalid, return "0"
  if (!numAmount || isNaN(numAmount)) {
    return '0';
  }
  
  // Format to 6 decimal places and remove trailing zeros
  return numAmount.toFixed(6).replace(/\.?0+$/, '');
};